import type { AccommodationReservationProvider } from "../../../__generated__/gql/graphql";

/**
 * 予約プロバイダの種別名を短縮して取得する関数
 *
 * @param provider - 予約プロバイダ
 *
 * @returns 予約プロバイダの種別名
 * 例: "StayTicketAccommodationReservationProvider" -> "StayTicket"
 */
export function getProviderTypeName(
  provider: Pick<AccommodationReservationProvider, "__typename">,
): string {
  return provider.__typename.replace(/AccommodationReservationProvider$/, "");
}
